import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class MongoService {

  constructor(
    private apiService: ApiService
  ) { }

  //admins
  public async getAllAdminData(): Promise<any> {
    return await this.apiService.getCollectionData("admins");
  }

  public async getAdminData(adminId: string): Promise<any> {
    return await this.apiService.getDocumentsByPropertyValue("admins", "adminId", adminId);
  }

  //benefits
  public async getAllPumpsBenefitsData(): Promise<any> {
    return await this.apiService.getCollectionData("pumps_benefits");
  }

  public async getAllAirconditionersBenefitsData(): Promise<any> {
    return await this.apiService.getCollectionData("airconditioners_benefits");
  }

  //orders
  public async getAirconditionersUsersOrders(): Promise<any> {
    return await this.apiService.getCollectionData("airconditioners_users_orders");
  }

  public async getPumpsUsersOrders(): Promise<any> {
    return await this.apiService.getCollectionData("pumps_users_orders");
  }

  public async getUserAirconditionersOrdersByEmail(userEmail: string): Promise<any> {
    return await this.apiService.getUserAirconditionersOrdersByEmail(userEmail);
  }

  public async getUserPumpsOrdersByEmail(userEmail: string): Promise<any> {
    return await this.apiService.getUserPumpsOrdersByEmail(userEmail);
  }

  public async addUserAirconditionersOrder(orderObject: any): Promise<any> {
    return await this.apiService.addObjectToCollection("airconditioners_users_orders", orderObject);
  }

  public async addUserPumpsOrder(orderObject: any): Promise<any> {
    return await this.apiService.addObjectToCollection("pumps_users_orders", orderObject);
  }

  public async deleteUsersOrdersByEmails(usersEmails:any): Promise<any> {
    return await this.apiService.deleteUsersOrdersByEmails(usersEmails);
  }

  //scores
  public async getAllPumpsScoresData(): Promise<any> {
    return await this.apiService.getCollectionData("pumps_scores");
  }

  public async addPumpsScore(scoreObject: any): Promise<any> {
    return await this.apiService.addObjectToCollection("pumps_scores", scoreObject);
  }

  public async deletePumpsScoringData(): Promise<any> {
    return await this.apiService.deleteCollectionData("pumps_scores");
  }

  public async getAllAirconditionersScoresData(): Promise<any> {
    return await this.apiService.getCollectionData("airconditioners_scores");
  }

  public async addAirconditionersScore(scoreObject: any): Promise<any> {
    return await this.apiService.addObjectToCollection("airconditioners_scores", scoreObject);
  }

  public async deleteAirconditionersScoringData(): Promise<any> {
    return await this.apiService.deleteCollectionData("airconditioners_scores");
  }

  //promoCampaign
  public async getPromoCampaignSettingsData(): Promise<any> {
    return await this.apiService.getCollectionData("promoCampaign");
  }

  public async savePromoCampaignSettingsData(campaignSettingsObject: any): Promise<any> {
    return await this.apiService.replaceCollectionData("promoCampaign", campaignSettingsObject);
  }

  //usersData
  public async getAllUsersData(): Promise<any> {
    return await this.apiService.getCollectionData("usersData");
  }

  public async deleteUsersData(): Promise<any> {
    return await this.apiService.deleteCollectionData("usersData");
  }

  public async deleteUsersDataByEmails(usersEmails:any): Promise<any> {
    return await this.apiService.deleteUsersDataByEmails(usersEmails);
  }

  public async addUsersData(usersDataObjects: Array<any>): Promise<any> {
    return await this.apiService.addObjectsToCollection("usersData", usersDataObjects);
  }

  // Atomowa podmiana całej kolekcji usersData. Backend wstawia dane do kolekcji
  // tymczasowej i wykonuje renameCollection(dropTarget) — brak okna częściowego
  // stanu, a przy błędzie prawdziwa kolekcja pozostaje nietknięta.
  public async replaceUsersData(usersDataObjects: Array<any>): Promise<any> {
    return await this.apiService.replaceUsersData(usersDataObjects);
  }

  public async clearWinnersStatus(): Promise<any> {
    return await this.apiService.clearWinnersQualifiedStatus();
  }

  // public async updateWinnersStatus(winnersList: Array<string>): Promise<any> {
  //   return await this.apiService.updateWinnersQualifiedStatus(winnersList);
  // }

  public async getUserData(userId: any): Promise<any> {
    return await this.apiService.getDocumentById("usersData",userId);
  }

  public async getUserDataByEmail(userEmail: any): Promise<any> {
    return await this.apiService.getUserDataByEmail(userEmail);
  }

  public async updateUserData(userData: any): Promise<any> {
    return await this.apiService.updateUserData(userData);
  }

  public async registerUserData(userData: any): Promise<any> {
    return await this.apiService.registerUserData(userData);
  }

  //prizes data
  public async clearPumpsPrizesData(): Promise<any> {
    return await this.apiService.deleteCollectionData("pumps_prizes");
  }

  public async setPumpsPrizes(prizesArr: any): Promise<any> {
    return await this.apiService.addObjectsToCollection("pumps_prizes", prizesArr);
  }

  public async getAllPumpsPrizesData(): Promise<any> {
    return await this.apiService.getCollectionData("pumps_prizes");
  }

  public async clearAirconditionersPrizesData(): Promise<any> {
    return await this.apiService.deleteCollectionData("airconditioners_prizes");
  }

  public async setAirconditionersPrizes(prizesArr: any): Promise<any> {
    return await this.apiService.addObjectsToCollection("airconditioners_prizes", prizesArr);
  }

  public async getAllAirconditionersPrizesData(): Promise<any> {
    return await this.apiService.getCollectionData("airconditioners_prizes");
  }

  //usersContacts
  public async getAllUsersContactsData(): Promise<any> {
    return await this.apiService.getCollectionData("usersContacts");
  }

  public async setUsersContactsData(contactsArr: any): Promise<any> {
    return await this.apiService.addObjectsToCollection("usersContacts", contactsArr);
  }

  public async deleteUsersContactsData(): Promise<any> {
    return await this.apiService.deleteCollectionData("usersContacts");
  }
}
